import { useSelector } from "react-redux";

import type { RootState } from "../store";

/**
 * Resolves the active Trivelta client's primary country code from the
 * Redux app-config slice (sourced from TCM's `app_currency_config` —
 * the BE field that flips per-client between US, MX, NG, etc.).
 *
 * Used by KPI V2 By-State maps so an admin viewing Infinito or
 * Estadio Gana sees the Mexico map, BetCorrect / Scorama see the
 * Nigeria map, and ReBet / DoggHouse see the US map.
 *
 * Returns `undefined` while the config slice is still loading; downstream
 * consumers (e.g. `<GeographicUserInsights>`) accept `undefined` and fall
 * back to the US map, which matches the legacy V1 behaviour and avoids
 * a blank surface on first render.
 *
 * Mirrors V1's `useSelector((state) => state.config).appConfig?.app_currency_config?.country`
 * pattern in `Sportsbook/Kpi/UsersByState/UsersByState.jsx` (line 43–44).
 */
export function useClientCountry(): string | undefined {
  return useSelector(
    (state: RootState) => state.config.appConfig?.app_currency_config?.country,
  );
}

export default useClientCountry;
